import Production from "./production/index.js";
import QualityControl from "./quality_control/index.js";
import QualityReports from "./quality_reports/index.js";
import Reporting from "./reporting/index.js";
import Certifications from "./certifications/index.js";
import Finances from "./finances/index.js";
import Liquidations from "./liquidations/index.js"
import Providers from "./providers/index.js";

export default [
  ...Liquidations,
  ...Production,
  ...QualityControl,
  ...QualityReports,
  ...Reporting,
  ...Certifications,
  ...Finances,
  ...Providers
];
